import React, {forwardRef, memo, useEffect} from "react";
import StarterKit from "@tiptap/starter-kit";
import ListItem from "@tiptap/extension-list-item";
import OrderedList from "@tiptap/extension-ordered-list";
import BulletList from "@tiptap/extension-bullet-list";
import Focus from "@tiptap/extension-focus";
import RenderCustomTable from "./Table/RenderCustomTable";
import {TableRow} from "@tiptap/extension-table-row";
import {TableHeader} from "@tiptap/extension-table-header";
import CustomTableCell from "./TableCell/tableCell";
// import Youtube from "@tiptap/extension-youtube";
import {Youtube} from "@/components/EditorV2/extension-youtube";
import ListKeymap from "@tiptap/extension-list-keymap";
import HardBreak from "@tiptap/extension-hard-break";
import latexBlock from "./latexMath/latexBlock";
import {UniqueID} from "@tiptap-pro/extension-unique-id";
import Gapcursor from "@tiptap/extension-gapcursor";
import Text from "@tiptap/extension-text";
import TextStyle from "@tiptap/extension-text-style";
import {Color} from "@tiptap/extension-color";
import Heading from "@tiptap/extension-heading";
import Paragraph from "@tiptap/extension-paragraph";
import Highlight from "@tiptap/extension-highlight";
import {imgPathPerfix, isDarkMode, isString, migrateInlineCodeToOfficial, sleep} from "../../utils";
import TextAlign from "@tiptap/extension-text-align";
import Underline from "@tiptap/extension-underline";
import {getBlockMenu} from "./BlockMenu/BlockMenu";
import {PopupCardPlus} from "../Plus/PopupCardPlus";
import Placeholder from "@tiptap/extension-placeholder";
import FontSize from "tiptap-extension-font-size";
import {Indent} from "./indent";
import Link from "./extension-link/src";
import ImageT from "@tiptap/extension-image";
import Image from "./imgResize";
import SearchNReplace from "./Search/plugin";
import {ImagePaste} from "./ImagePaste";
import TaskList from "@tiptap/extension-task-list";
import TaskItem from "@tiptap/extension-task-item";
import HorizontalRule from "@tiptap/extension-horizontal-rule";
import Blockquote from "@tiptap/extension-blockquote";
import {FontFamily} from "@tiptap/extension-font-family";
import CodeBlockLowlight from "@tiptap/extension-code-block-lowlight";
import {EditorContent, ReactNodeViewRenderer, useEditor} from "@tiptap/react";
import CodeBlockComponent from "./CodeBlock3";
import {lowlight} from "lowlight";
import Background from 'tiptap-extension-background-color'
import DeeplinkNode from "../Deeplink/DeeplinkNode";
import './EditCardItem.css'
import {MAP_HIGHLIGHT_COLOR_L_2_D} from "@/Const";
import {mergeAttributes} from "@tiptap/core";
import {Plugin, PluginKey} from "prosemirror-state";
import Table from "@tiptap/extension-table";
import CustomTableExtend from "@/components/EditorV2/Table/CustomTableExtend";
import Mathematics from "@tiptap-pro/extension-mathematics";
import {getHeadingExtend} from "@/components/EditorV2/EditorExtensions/HeadingExtend";
import {InlineCodeMark} from "@/components/EditorV2/InlineCodeMark/InlineCodeMark";
import latexInline from "@/components/EditorV2/latexInline/latexInline";
import CodeInlie from '@tiptap/extension-code'
import { t } from "i18next";

const EditorCardItem = forwardRef((props:{data:any,itemHeight:any,from?:any}, ref) => {
    const extensions = [
        StarterKit,
        ListItem,
        OrderedList.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    blockHighlight: {
                        default: false,
                    },
                    noteText: {
                        default: ''
                    }
                };
            },
        }),
        BulletList.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    blockHighlight: {
                        default: false,
                    },
                    noteText: {
                        default: ''
                    }
                };
            },
        }),
        Youtube.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    highlightImgUrl: {
                        default: '',
                    },
                    noteText: {
                        default: ''
                    }
                };
            },
        }),
        ListKeymap,
        HardBreak.extend({

        }),
        // Mathematics.configure({
        //     // regex: /\&\&([^\&]*)\&\&/gi
        // }),
        latexBlock,
        TextStyle,
        Color,
        getHeadingExtend('EditorCardItem'),
        Highlight.configure({ multicolor: true }).extend({
            addAttributes() {
                return {
                    ...this.parent?.(),
                    id: {
                        default: crypto.randomUUID()
                    },
                    noteText: {
                        default: '',
                    },
                };
            },
            addCommands() {
                return {
                    ...this.parent?.(),
                    setHighlightId: (id,from) =>async  ({ tr, state, dispatch }) => {
                        await sleep(30)
                        const resolvedPos = this.editor.state.doc.resolve(from);
                        // 获取当前节点  实际id已经改变了，只是渲染的id值没变 重新渲染即可
                        const currentNode = resolvedPos.node().content.content[0];
                        currentNode.marks[0].attrs={...currentNode.marks[0].attrs,id:id}
                        return true;
                    }
                };
            }
        }),
        TextAlign.configure({
            types: ["heading", "paragraph"],
        }),
        Underline,
        Background,
        FontSize,
        Indent,
        Link.configure({
            protocols: ['noteey'],
            autolink: false,
            linkOnPaste: false,
        }),
        TaskList.extend({
            addAttributes() {
                return {
                    ...this.parent?.(), // 保留原有的属性
                    blockHighlight: {
                        default: false,
                    },
                    noteText: {
                        default: ''
                    }
                };
            },
        }),
        TaskItem.configure({
            nested: true,
        }),
        CodeBlockLowlight.extend({
            addAttributes(){
                return{
                    from:{
                        default:'EditorCardItem'
                    }
                }
            },
            addNodeView() {
                return ReactNodeViewRenderer(CodeBlockComponent,{attrs:{from:'fljfldsjf'}});
            },
        }).configure({lowlight}),
        DeeplinkNode.configure({
            fontSize: '12px',
            marginTopImg:'1px',
            containerMarginTop:'0px',
            forceMarginTopImg:true,
            from:'EditorCardItem'
        }),
        RenderCustomTable.configure({
            resizable: true,
            allowTableNodeSelection: true,
        }).extend({
            addAttributes(){
                return{
                    from:{
                        default:'EditorCardItem'
                    }
                }
            }
        }),
        TableHeader,
        CustomTableCell,
        TableRow,
        // InlineCodeMark,
        CodeInlie,
        latexInline,
        ImageT.extend({
            addAttributes() {
                return {
                    ...this.parent?.(),
                    noteText: {
                        default: '',
                    },
                };
            }
        }),
    ]
    const editor = useEditor({
        injectCSS: true,
        extensions:extensions,
        editable:false,
        parseOptions: {
            preserveWhitespace: 'full',
        },
        onCreate(editor){
            editor.editor.view.dom.classList.remove('ProseMirror');
            editor.editor.view.dom.classList.add('ProseMirror-editor-card-item');
            editor.editor.view.dom.classList.add('node-codeBlock');
            setDocContent(editor.editor);
        }
    });

    /**
     * 设置缩略图....
     * @param editor
     */
    const setDocContent = (editor)=>{
        // editor?.commands.setContent('');
        let szDoc = props.data?.thumbHtml;
        if (szDoc && isDarkMode()){
            const arrayHighKeys = Object.keys(MAP_HIGHLIGHT_COLOR_L_2_D);
            arrayHighKeys.forEach(p=>{
                szDoc = szDoc.replaceAll(p,MAP_HIGHLIGHT_COLOR_L_2_D[p]);
            })
        }
        setTimeout(()=>{
            editor?.commands.setContent(migrateInlineCodeToOfficial(szDoc));
        },10)
    }

    useEffect(()=>{
        if (editor){
            setDocContent(editor);
        }
    },[props.data])

    const getHeight = ()=>{
        // if (props.data.type == 'journal'){
        //     return props.itemHeight;//日记标题有固定的高度
        // }
        // const span = document.getElementById('card-item-title-'+props.data.id);
        // if (span){
        //     return props.itemHeight - span.offsetHeight;
        // }
        return props.itemHeight;
    }

    const getHeight1 = ()=>{
        let nH = getHeight();
        if (nH < 0){
            nH = 0;
        }
        return nH;
    }

    const isEmptyTitle = ()=>{
        if (props.data.hasTitle != undefined){
            if (!props.data.hasTitle){
                return true;
            }
        }
        if (isString(props.data?.name)){
            return !props.data?.name || props.data?.name?.toLowerCase() == t('Untitled').toLowerCase();
        }
        return true;
    }

    return(
        <>
            {
                editor &&
                <EditorContent style={{fontSize:'12px',marginTop:isEmptyTitle()?'8px':'8px',height:(getHeight1())+'px',pointerEvents:'none',marginLeft:'4px'}}
                               editor={editor}/>
            }
        </>
    )
})

export default React.memo(EditorCardItem)
